import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import logo from '../assets/logo.png';
import login_bg from '../assets/login_bg.jpg';
import logo_worded_only from '../assets/logo_worded_only.png';
import { callApi, getCookie, getInlineLoader, setCookie } from "../Helpers";
import { MdArrowCircleLeft, MdArrowCircleRight, MdCircle, MdLock, MdLogin, MdOutlinePhonelinkLock, MdPassword, MdPerson, MdPhone, MdPhoneAndroid, MdPhonelinkLock, MdPhoneLocked } from "react-icons/md";
import { GiLovers, GiTalk } from "react-icons/gi";
import { FaUserDoctor } from "react-icons/fa6";
import {
  STR_APP_NAME,
  STR_CHANGE_LANGUAGE,
  STR_CHANGE,
  STR_CONFIRM,
  STR_CONTINUE,
  STR_ENTER,
  STR_ENTER_EMAIL_ADDRESS,
  STR_ENTER_OTP,
  STR_ENTER_YOUR_PHONE_NUMBER,
  STR_FORGOT_PASSWORD,
  STR_GET_STARTED,
  STR_HEALTH,
  STR_INVALID_CONFIRM_PASSWORD,
  STR_INVALID_EMAIL,
  STR_INVALID_OTP,
  STR_INVALID_PASSWORD,
  STR_INVALID_PHONE,
  STR_PASSWORD,
  STR_PLEASE_WAIT,
  STR_RELATIONSHIPS,
  STR_RESEND_OTP,
  STR_STORIES,
  STR_USE_EMAIL,
  STR_USE_PHONE,
  STR_WELCOME,
  STR_LOGIN_TO_CONTINUE,
  STR_LOGIN_NOW,
  STR_YOUR_PHONE,
  STR_PHONE_NUMBER,
  STR_YOUR_OTP_VERIFICATION,
  STR_CHANGE_PHONE,
  STR_INTRO_2
} from "../Strings";

export default function Login(props) {

  const appContext = useContext(AppContext);

  const [loading, setLoading] = useState(false);
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loginStep, setLoginStep] = useState("identity");
  const [identity, setIdentity] = useState('phone');

  async function init() {
    const storedPhone = getCookie("phone");
    const storedEmail = getCookie("email");
    const storedLoginStep = getCookie("loginStep");

    if (storedLoginStep) {
      setLoginStep(storedLoginStep);

      if (storedPhone) {
        setPhone(storedPhone);
      }

      if (storedEmail) {
        setEmail(storedEmail);
      }
    }
  }

  async function resendOtp() {
    if (!loading) {
      if (String(phone).trim().length >= 9 || String(email).trim().length > 0) {

        setLoading(true);
        await callApi(
          "resend-otp",
          {
            phone: `255${parseInt(phone, 10)}`,
            identity,
            email
          }
        ).then((response) => {
          if (response.status === 1) {
            setCookie('phone', phone);
            setCookie('email', email);
            setCookie('loginStep', response.nextLoginStep);
            setLoginStep(response.nextLoginStep);

          } else {
            appContext.tellError(response.msg);
          }
        })
        setLoading(false);

      } else {
        appContext.tellError(STR_INVALID_PHONE[appContext.language]);
      }
    } else {
      appContext.tellInfo(STR_PLEASE_WAIT[appContext.language]);
    }
  }

  async function phoneLogin() {
    if (!loading) {
      if (String(phone).trim().length >= 9) {

        setLoading(true);
        await callApi(
          "phone-login",
          {
            phone: `255${parseInt(phone, 10)}`,
          }
        ).then((response) => {
          if (response.status === 1) {
            setCookie('phone', phone);
            setCookie('loginStep', response.nextLoginStep);
            setLoginStep(response.nextLoginStep);

          } else {
            appContext.tellError(response.msg);
          }
        })
        setLoading(false);

      } else {
        appContext.tellError(STR_INVALID_PHONE[appContext.language]);
      }
    } else {
      appContext.tellInfo(STR_PLEASE_WAIT[appContext.language]);
    }
  }

  async function emailLogin() {
    if (!loading) {
      if (String(email).trim().length > 0) {

        setLoading(true);
        await callApi(
          "email-login",
          {
            email,
          }
        ).then((response) => {
          if (response.status === 1) {
            setCookie('email', email);
            setCookie('loginStep', response.nextLoginStep);
            setLoginStep(response.nextLoginStep);

          } else {
            appContext.tellError(response.msg);
          }
        })
        setLoading(false);

      } else {
        appContext.tellError(STR_INVALID_EMAIL[appContext.language]);
      }
    } else {
      appContext.tellInfo(STR_PLEASE_WAIT[appContext.language]);
    }
  }

  async function forgotPassword() {
    if (!loading) {
      if (String(phone).trim().length >= 9 || String(email).trim().length > 0) {

        setLoading(true);
        await callApi(
          "forgot-password",
          {
            phone: `255${parseInt(phone, 10)}`,
            email,
            identity,
          }
        ).then((response) => {
          if (response.status === 1) {
            setCookie('phone', phone);
            setCookie('loginStep', response.nextLoginStep);
            setLoginStep(response.nextLoginStep);

          } else {
            appContext.tellError(response.msg);
          }
        })
        setLoading(false);

      } else {
        appContext.tellError(STR_INVALID_PHONE[appContext.language]);
      }
    } else {
      appContext.tellInfo(STR_PLEASE_WAIT[appContext.language]);
    }
  }

  async function otpLogin() {
    if (!loading) {
      if (otp.trim().length === 6) {
        
        setLoading(true);
        await callApi(
          "otp-login",
          {
            phone: `255${parseInt(phone, 10)}`,
            otp,
            identity,
            email,
          }
        ).then((response) => {
          if (response.status === 1) {
            setCookie('phone', '');
            setCookie('email', '');
            setCookie('loginStep', '');

            setCookie("userId", response.user.id);
            setCookie("userToken", response.user.token);

            appContext.navTo({
              item: 'home',
            })

            //refresh app
            appContext.refresh(); //delay hack

            appContext.tellMessage(STR_WELCOME[appContext.language]);
          } else {
            appContext.tellError(response.msg);
          }
        })
        setLoading(false);
          
      } else {
        appContext.tellError(STR_INVALID_OTP[appContext.language]);
      }
    } else {
      appContext.tellInfo(STR_PLEASE_WAIT[appContext.language]);
    }
  }



  async function passwordLogin() {
    if (!loading) {
      if (password.trim().length >= 8) {
        setLoading(true);
        await callApi(
          "password-login",
          {
            phone: `255${parseInt(phone, 10)}`,
            email,
            identity,
            otp,
            password,
          }
        ).then((response) => {
          if (response.status === 1) {
            setCookie('phone', '');
            setCookie('loginStep', '');

            setCookie("userId", response.user.id);
            setCookie("userToken", response.user.token);

            appContext.navTo({
              item: 'home',
            })

            //refresh app
            appContext.refresh(); //delay hack

            appContext.tellMessage(STR_WELCOME[appContext.language]);
          } else {
            appContext.tellError(response.msg);
          }
        })
        setLoading(false);

      } else {
        appContext.tellError(STR_INVALID_PASSWORD[appContext.language])
      }

    } else {
      appContext.tellInfo(STR_PLEASE_WAIT[appContext.language]);
    }
  }

  useEffect(() => {
    init();
  }, [])

  useEffect(() => {
    appContext.setShowOverlayLoader(loading);
    
  }, [loading])

  return (
    <div
      className="bg-sub-gradient"
      style={{
        width: "100%",
        height: "100%",
        backgroundImage: `url(${login_bg})`,
        backgroundAttachment: 'fixed',
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }}
    >

      {
        (loginStep === 'identity') ?
        <div
          className="container"
          style={{
            paddingTop: "100px"
          }}
        >
          

          <div
            style={{
              maxWidth: "420px",
              margin: "10px auto",
              padding: "30px",
              borderRadius: "20px"
            }}
            className="mShadow3 bg-surface"
          >

            <h6
              style={{
                fontSize: "24px"
              }}
              className="font-bold"
            >
              {STR_YOUR_PHONE[appContext.language]}!
            </h6>

            <div
              style={{
                marginTop: "40px",
                marginBottom: "40px",
              }}
            >
              <label>{STR_PHONE_NUMBER[appContext.language]}</label>
              
              <div
                className="input-group"
              >
                <span
                  className="input-group-text font-semi-bold text-secondary"
                  style={{
                    fontSize: "16px"
                  }}
                >
                  +255
                </span>
                <input
                  className="form-control"
                  onChange={(e) => setPhone(_prev => {
                    if (Number(e.target.value)) {
                      return Number(e.target.value);
                    } else if (String(e.target.value).trim().length === 0) {
                      return "";
                    } else {
                      return _prev;
                    }
                  })}
                  value={phone}
                  maxLength={10}
                  placeholder="XXX XXX XXX"
                  type="text"
                  style={{
                    fontSize: "16px"
                  }}
                />
              </div>
              <div className="form-text mb-3 mt-3">
                {STR_ENTER_YOUR_PHONE_NUMBER[appContext.language]}
              </div>
              
            </div>


            <div
              className=""
            >
              <h6
                style={{
                  cursor: "pointer",
                  fontSize: "14px"
                }}
                className="text-primary font-bold"
                onClick={() => appContext.changeLanguage()}
              >
                <MdArrowCircleRight size={16}/>
                {STR_CHANGE_LANGUAGE[appContext.language]}
              </h6>
            </div>

          </div>


          <div
            style={{
              paddingTop: "40px",
              paddingBottom: "40px",
            }}
            className="text-center"
          >
            <button 
              className="btn btn-rounded btn-padded btn-primary"
              style={{
                fontSize: "16px",
                textTransform: "uppercase"
              }}
              onClick={phoneLogin}
            >
              {STR_CONTINUE[appContext.language]}
            </button>
          </div>
        </div>
        :""
      }

      {
        (loginStep === 'otp') ?
        <div
          className="container"
          style={{
            paddingTop: "100px"
          }}
        >
          

          <div
            style={{
              maxWidth: "420px",
              margin: "10px auto",
              padding: "30px",
              borderRadius: "20px"
            }}
            className="mShadow3 bg-surface"
          >

            <h6
              style={{
                fontSize: "24px"
              }}
              className="font-bold"
            >
              {STR_YOUR_OTP_VERIFICATION[appContext.language]}!
            </h6>

            <div
              style={{
                marginTop: "40px",
                marginBottom: "40px",
              }}
            >
              <label>OTP</label>
              
              <input
                className="form-control"
                onChange={e => setOtp(e.target.value)}
                value={otp}
              />
              <div className="form-text mb-3 mt-3">
                {STR_ENTER_OTP[appContext.language]}
              </div>
              
            </div>


            <div
              className=""
            >
              

              <h6
                style={{
                  cursor: "pointer",
                  fontSize: "14px"
                }}
                className="text-primary font-bold"
                onClick={() => {
                  setLoginStep('identity');

                }}
              >
                <MdArrowCircleRight size={16}/>
                {STR_CHANGE_PHONE[appContext.language]}
              </h6>

              <h6
                style={{
                  cursor: "pointer",
                  fontSize: "14px"
                }}
                className="text-primary font-bold"
                onClick={() => {
                  resendOtp()
                }}
              >
                <MdArrowCircleRight size={16}/>
                {STR_RESEND_OTP[appContext.language]}
              </h6>

              <h6
                style={{
                  cursor: "pointer",
                  fontSize: "14px"
                }}
                className="text-primary font-bold"
                onClick={() => appContext.changeLanguage()}
              >
                <MdArrowCircleRight size={16}/>
                {STR_CHANGE_LANGUAGE[appContext.language]}
              </h6>
            </div>

          </div>


          <div
            style={{
              paddingTop: "40px",
              paddingBottom: "40px",
            }}
            className="text-center"
          >
            <button 
              className="btn btn-rounded btn-padded btn-primary"
              style={{
                fontSize: "16px",
                textTransform: "uppercase"
              }}
              onClick={otpLogin}
            >
              {STR_CONTINUE[appContext.language]}
            </button>
          </div>
        </div>
        :""
      }
      
    </div >
  )
}